import { NgModule } from '@angular/core';
import { CapRuleListComponent } from './Cap-Rule-List/capRuleList.component';
import { CapRuleRepository } from '../Compliance/Repositories/capRule.repository';
import { HybridAdapterUtility } from '../Hybrid/hybrid-adapter.utility';
import { WsAgGridWrapperComponent } from '../Compliance/AgGrid/AgGridWrapper/wsAgGridWrapper.component';
import { TaxRateModule } from '../Tax-Rate/tax.rate.module';
import { PercentIncreaseCellRenderer } from './Cap-Rule-List/agGridPercentIncreaseCellRenderer.component';
import { CommonModule, NgIf, PercentPipe } from '@angular/common';
import { HelpModule } from '../UI-Lib/Help-Tooltip/help.module';
import { CapRuleDetailsComponent } from './Cap-Rule-Details/capRuleDetails.component';
import { ModalWrapperComponent } from '../UI-Lib/Modal-Wrapper/modalWrapper.component';
import { AddressViewEditComponent } from '../Common/Address/Address-View-Edit/address.view.edit.component';
import { EntityAttachmentsComponent } from '../Attachment/Entity/entity-attachments.component';
import { EntityCommentsButtonComponent } from '../Comments/Entity-Comments-Button/entityCommentsButton.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BusyIndicatorModule } from '../Busy-Indicator';
import { StateDropdownComponent } from '../Common/States/State-Dropdown/state.dropdown.component';
import { WeissmanSharedModule } from '../Common/weissman-shared.module';
import { CapRuleListGridActionCellRendererComponent } from './Cap-Rule-List/agGridActionCellRenderer.component';

@NgModule({
    imports: [
        CommonModule,
        WeissmanSharedModule,
        WsAgGridWrapperComponent,
        TaxRateModule,
        PercentPipe,
        HelpModule,
        ModalWrapperComponent,
        AddressViewEditComponent,
        EntityAttachmentsComponent,
        EntityCommentsButtonComponent,
        FormsModule,
        BusyIndicatorModule,
        ReactiveFormsModule,
        StateDropdownComponent,
        NgIf
    ],
    declarations: [
        CapRuleListComponent,
        PercentIncreaseCellRenderer,
        CapRuleDetailsComponent,
        CapRuleListGridActionCellRendererComponent
    ],
    providers: [
        CapRuleRepository
    ],
    exports: [
        CapRuleListComponent,
        CapRuleDetailsComponent,
        CapRuleListGridActionCellRendererComponent
    ]
})
export class CapRuleListModule {
    static setupModule(): void {
        const hybridAdapterUtility = new HybridAdapterUtility();
        hybridAdapterUtility.downgradeNg2Component('capRuleList', CapRuleListComponent);
    }
}
